import { FC } from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const FinancialNavArrowIcon: FC<IProps> = ({ color = '#003349', ...props }) => {
  return (
    <svg
      width={23}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 9a1 1 0 100-2v2zM.293 7.293a1 1 0 000 1.414l6.364 6.364a1 1 0 001.414-1.414L2.414 8l5.657-5.657A1 1 0 006.657.93L.293 7.293zM22 7H1v2h21V7z"
        fill={color}
      />
    </svg>
  );
};

export default FinancialNavArrowIcon;
